import { Component, OnInit } from '@angular/core';
import { IdNowCommonResponse, UploadFaceRequest, QueryEnrollmentResponse } from 'src/app/services/idnow-backend-services-domain';
import { NotificationService } from 'src/app/services/notification.service';
import { IdnowBackendsService } from 'src/app/services/idnow-backend-services';

@Component({
  selector: 'idnow-final-result',
  templateUrl: './final-result.component.html',
  styleUrls: ['./final-result.component.css']
})
export class FinalResultComponent implements OnInit {

  constructor(private idnowServices : IdnowBackendsService, private notifyService : NotificationService) { }

  imageSelfie : string;
  selfieResponse : IdNowCommonResponse;
  enrollStatus : string;
  dniResponse : IdNowCommonResponse;
  names : string;
  surnames : string;
  number: string;
  baseResponse: QueryEnrollmentResponse;
  uploadFaceRequest : UploadFaceRequest;

  ngOnInit() {
      try{
        this.dniResponse = this.idnowServices.getDniData();

        this.dniResponse.additionalResponseAttrs.forEach( (element) => {
          if(element.key == 'NAMES'){
            this.names = element.value;
          }
          if(element.key == 'SURNAMES'){
            this.surnames = element.value;
          }
        });

        this.number = this.idnowServices.getBaseResponse().commonUserDataRequest.userId;

        this.imageSelfie = this.idnowServices.getBase64Face();
        
        this.idnowServices.finalMatchFace(uploadFaceRequest => {
          this.notifyService.showInfo("Finalizando enrolamiento", "Informacion");

          this.idnowServices.finishEnrollment(uploadFaceRequest, 
            () => this.enrollStatus = 'Aprobado',
            () => this.enrollStatus = 'Rechazado');
        }, () =>  this.enrollStatus = 'Rechazado');
      } catch(error) {
        console.log('Error en componente: ', error);
        this.notifyService.showError("Lo lamentamos, no pudimos procesar su fotografia", "ERROR")
        location.href = "/frontFace";
      }
  }
}